
import AddToCartError from './AddToCartError.vue';
import Icon from 'JS/components/Icon.vue';
import UiButton from 'JS/components/UiButton.vue';
import Vue, { PropType } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { fulfillmentOptionToString } from 'JS/helpers/FulfillmentHelper';
import { FulfillmentType } from 'JS/types/ProductDelivery';
import { icons } from 'JS/constants/icons';
import { RequireConfirmationResponse } from 'JS/services/ProductService';

@Component({
	name: 'DeliveryConfirmation',
	components: {
		Icon,
		AddToCartError,
		UiButton
	}
})
export default class DeliveryConfirmationSidebar extends Vue {
	@Prop({ type: Object as PropType<RequireConfirmationResponse>, required: true })
	readonly deliveryConfirmationInfo: RequireConfirmationResponse;

	get isLocalDelivery(): boolean {
		return this.deliveryConfirmationInfo.fulfillmentType === FulfillmentType.LocalDelivery;
	}

	get isShipping(): boolean {
		return this.deliveryConfirmationInfo.fulfillmentType === FulfillmentType.StandardShipping;
	}

	get isPickup(): boolean {
		return this.deliveryConfirmationInfo.fulfillmentType === FulfillmentType.InStorePickup;
	}

	get fulfillmentCalloutText(): string {
		return this.getFulfillmentText(this.deliveryConfirmationInfo.fulfillmentType);
	}

	get orderFulfillmentCalloutText(): string {
		return this.getFulfillmentText(this.deliveryConfirmationInfo.orderFulfillmentOption);
	}

	get fulfillmentIcon(): string {
		if (this.isLocalDelivery) return icons.localdeliver;
		else if (this.isPickup) return icons.drive_thru;
		else return icons.truck;
	}

	removeIcon: string = icons.remove;

	getFulfillmentText(fulfillmentType: FulfillmentType): string {
		return fulfillmentOptionToString(fulfillmentType);
	}

}
